import apiClient from './client';
import { ExamType, DtmDirection } from './exams';
import { Subject, Topic } from './subjects';
import { Question } from './questions';

export interface TestPaperQuestion {
  id: string;
  test_paper_id: string;
  question_id: string;
  subject_id: string;
  role: 'primary' | 'secondary' | 'mandatory' | null;
  sort_order: number;
  question?: Question;
  subject?: Subject;
}

export interface TestPaper {
  id: string;
  exam_type_id: string;
  dtm_direction_id: string | null;
  subject_id: string | null;
  topic_id: string | null;
  year: number | null;
  variant_number: number;
  title: string;
  total_questions: number;
  time_limit_minutes: number | null;
  is_active: boolean;
  source_file: string | null;
  created_at: string;
  updated_at: string;
  exam_type?: ExamType;
  dtm_direction?: DtmDirection;
  subject?: Subject;
  topic?: Topic;
  paper_questions?: TestPaperQuestion[];
}

export interface TestPapersFilters {
  exam_type_slug?: string;
  dtm_direction_id?: string;
  subject_id?: string;
  year?: number;
}

export const testPapersApi = {
  getAll: async (filters: TestPapersFilters = {}): Promise<TestPaper[]> => {
    const response = await apiClient.get<TestPaper[]>('/test-papers', { params: filters });
    return response.data;
  },

  getById: async (id: string): Promise<TestPaper> => {
    const response = await apiClient.get<TestPaper>(`/test-papers/${id}`);
    return response.data;
  },

  getYears: async (
    examTypeSlug: string,
    dtmDirectionId?: string,
  ): Promise<{ year: number; count: number }[]> => {
    const response = await apiClient.get<{ year: number; count: number }[]>(
      '/test-papers/years',
      { params: { exam_type_slug: examTypeSlug, dtm_direction_id: dtmDirectionId } },
    );
    return response.data;
  },
};
